import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';

import { UNIT_GROUPS, GROUPS_MAP, GROUPS } from '../config';

function GroupGrid({ filterState, handleFilterClick, groupContainerRef }) {
    const intl = useIntl();
    const [groupOpen, setGroupOpen] = useState(false);

    useEffect(() => {
        function handleClickOutside(event) {
            if (groupContainerRef.current && !groupContainerRef.current.contains(event.target)) {
                setGroupOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupOpen]);

    useEffect(() => {
        const handleContentPosition = () => {
            const groupContainers = document.querySelectorAll('.group-container');

            groupContainers.forEach(container => {
                const content = container.querySelector('.group-content');
                if (!content) return;

                const containerRect = container.getBoundingClientRect();
                const viewportCenter = window.innerWidth / 2;

                if (containerRect.left + containerRect.width / 2 < viewportCenter) {
                    content.style.left = '0';
                    content.style.right = 'auto';
                } else {
                    content.style.right = '0';
                    content.style.left = 'auto';
                }
            });
        };

        handleContentPosition();

        window.addEventListener('resize', handleContentPosition);

        return () => {
            window.removeEventListener('resize', handleContentPosition);
        };
    }, [groupOpen]);

    return (
        <div ref={groupContainerRef} className="group-container">
            <div onClick={() => setGroupOpen(!groupOpen)} className="buff-title-container">
                <div>
                    <FormattedMessage
                        id="sort.groups"
                        defaultMessage="Groups"
                    />
                </div>
                <div className="filter-bubble">
                    {filterState.groups.length === 0 || filterState.groups.length === UNIT_GROUPS.length ? intl.formatMessage({ id: 'sort.all', defaultMessage: 'All' }) : filterState.groups.length}
                </div>
            </div>
            <div className={`group-title-padding ${groupOpen ? 'open' : ''}`}></div>
            {groupOpen && (
                <div className="group-content">
                    <div className="group-grid">
                        {UNIT_GROUPS.map(group => {
                            const key = Object.keys(GROUPS_MAP).find(key => GROUPS_MAP[key].includes(group)) || "others";
                            const imageKey = key.toLowerCase().replace(" ", "_");
                            return (
                                <div
                                    key={group}
                                    onClick={() => handleFilterClick('groups', group)}
                                    className={`group-title-selector ${filterState.groups.includes(group) ? 'selected' : ''}`}
                                >
                                    <img
                                        className="character-group-image"
                                        src={GROUPS[imageKey]}
                                        alt={key}
                                    />
                                    <p>{group}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

        </div>
    );
}

export default GroupGrid;